import axios, { Axios } from 'axios';
import { VersionedTransaction } from '@solana/web3.js';
import bs58 from 'bs58';

export class Jito {
    private readonly axiosClient;

    constructor(blockEngineUrl: string) {
        this.axiosClient = axios.create({
            baseURL: blockEngineUrl,
        });
    }

    public tipAccounts = async () => {
        try {
            const res = await this.axiosClient.post('/api/v1/bundles', {
                jsonrpc: '2.0',
                id: 1,
                method: 'getTipAccounts',
                params: [],
            });
            return res.data.result as string[];
        } catch (error) {
            console.error('Error fetching tip accounts:', error);
            throw error;
        }
    };

    public sendBundle = async (versionedTransactions: VersionedTransaction[]) => {
        try {
            const res = await this.axiosClient.post('/api/v1/bundles', {
                jsonrpc: '2.0',
                id: 1,
                method: 'sendBundle',
                params: [versionedTransactions.map((tx) => bs58.encode(tx.serialize()))],
            });
            return res.data.result as string;
        } catch (error) {
            console.error('Error sending bundle:', error);
            throw error;
        }
    };
}
